document.addEventListener('DOMContentLoaded', function () {
    const menuButton = document.querySelector('[aria-controls="mobile-menu"]');
    const menu = document.getElementById('mobile-menu');
    if (!menuButton || !menu) return;

    function closeMenu() {
        menu.classList.add('hidden');
        menuButton.setAttribute('aria-expanded', 'false');
    }

    menuButton.addEventListener('click', () => {
        const expanded = menuButton.getAttribute('aria-expanded') === 'true';
        menuButton.setAttribute('aria-expanded', String(!expanded));
        menu.classList.toggle('hidden');
    });

    // Sluit het menu bij een linkklik. Voor een same-page anchor (bv. de
    // "Gratis schatting"-knop = /#adres-zoekbox terwijl je al op de homepage bent)
    // scrollen we zelf naar het doel — anders bleef het menu eroverheen openstaan
    // en scrollde de browser niet omdat de hash al gelijk was.
    menu.querySelectorAll('a[href]').forEach((link) => {
        link.addEventListener('click', (event) => {
            closeMenu();
            const href = link.getAttribute('href') || '';
            const hashIndex = href.indexOf('#');
            if (hashIndex !== -1) {
                const id = href.slice(hashIndex + 1);
                const target = id ? document.getElementById(id) : null;
                if (target) {
                    event.preventDefault();
                    requestAnimationFrame(() => {
                        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    });
                }
            }
        });
    });
});
